import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import ImpargoSpinner from '@impargo/components/Spinner';
const Spinner = ({ className, 'data-testid': dataTestId }) => (_jsx("div", Object.assign({ className: className, "data-testid": dataTestId }, { children: _jsx(ImpargoSpinner, {}) })));
export default styled(Spinner) `
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpointDesktop}) {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colorPrimary};
  }
`;
